/* eslint-disable react/jsx-props-no-spreading */
import { Input } from 'antd';
import ReactInputMask from 'react-input-mask';

export const InputPhone = (props) => (
    <ReactInputMask {...props}>
        {(inputProps) => (
            <Input
                {...inputProps}
                // eslint-disable-next-line
                disabled={props.disabled ? props.disabled : null}
            />
        )}
    </ReactInputMask>
);
